/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// material
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import AlertDialog from 'src/components/common-components/AlertDialog';
import { useDispatch, useSelector } from 'src/redux/store';
import { useSnackbar } from 'notistack5';

import TableSearch from 'src/components/table/TableSearch';

import { VENDOR_LIST_HEAD } from 'src/constants/Dashboard';

import {
  filterVendor,
  deleteVendor,
  statusChange,
  resetCreateVendorStatus,
  resetVendorMsg
} from 'src/redux/slices/vendor';

// ----------------------------------------------------------------------

VendorList.propTypes = {
  setEditId: PropTypes.func,
  deleteId: PropTypes.string,
  setDeleteId: PropTypes.func,
  vendorList: PropTypes.array,
  vendorListStatus: PropTypes.bool,
  setVendorListStatus: PropTypes.func
};
export default function VendorList({
  setEditId,
  deleteId,
  setDeleteId,
  vendorList,
  setVendorListStatus,
  vendorListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createVendorStatus, vendorMsg } = useSelector((state) => state.vendor);

  useEffect(() => {
    if (createVendorStatus) {
      enqueueSnackbar('Vendor Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateVendorStatus());
    }
    if (vendorMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetVendorMsg());
      setTiltle('Disable Vendor');
      setContent(vendorMsg);
    }
  }, [vendorMsg, createVendorStatus]);

  const handleVendorListSwitch = (e) => {
    setVendorListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete vendor');
    setContent('Are you sure want to delete vendor data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteVendor(deleteId));
    enqueueSnackbar('Vendor Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('Vendor Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={VENDOR_LIST_HEAD}
          tableData={vendorList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={vendorListStatus}
          switchButton
          filterComponent={filterVendor}
          switchButtonResponse={handleVendorListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
